import { useEffect, useState } from "react";
import { Button, Notice } from "@omnabase/ui";
import type { MyInvitation } from "@omnabase/shared";
import { useNavigate } from "../lib/nav";
import { useSession } from "../shell/store";
import { acceptInvitation, declineInvitation } from "../lib/invitations";
import { joinedToast } from "./signin/SignInSteps";

/** M11 round one (brief choice 4): an invitation into another workspace, for a person who already belongs somewhere, is never accepted for
 *  them: Home shows "<inviter> invited you to <workspace>" with Accept and Decline until they decide. Polish round two: the invitations come
 *  with Home's read (`invitations`), not a read of their own after it. */
export function InvitationNotices({ invitations }: { invitations: MyInvitation[] }) {
  const { reloadMe, toast } = useSession();
  const navigate = useNavigate();
  const [list, setList] = useState<MyInvitation[]>(() => invitations.filter((i) => !i.expired));
  useEffect(() => setList(invitations.filter((i) => !i.expired)), [invitations]);
  const accept = async (inv: MyInvitation) => {
    try { const j = await acceptInvitation(inv.id); await reloadMe(); joinedToast([j]); navigate(`/${j.slug}`); } catch (e) { toast(e instanceof Error ? e.message : "Could not accept", { kind: "error" }); }
  };
  const decline = async (inv: MyInvitation) => {
    try { await declineInvitation(inv.id); setList((l) => l.filter((x) => x.id !== inv.id)); toast(`Invitation to ${inv.workspace.name} declined`, { kind: "success" }); } catch (e) { toast(e instanceof Error ? e.message : "Could not decline", { kind: "error" }); }
  };
  return <>{list.map((inv) => (
    <Notice key={inv.id} icon="personAdd" action={<span className="ob-invite-notice__actions"><Button size="sm" onClick={() => void decline(inv)}>Decline</Button><Button variant="primary" size="sm" onClick={() => void accept(inv)}>Accept</Button></span>}>
      <strong>{inv.inviter.name} invited you to {inv.workspace.name}</strong>
    </Notice>
  ))}</>;
}
